<template>
  <div class="container-banner">
    <p class="accent"><AnimationAi class="icon-medium" /> ComingSoon</p>
    <p class="">
      대한민국에 11월, 스콘챗이 찾아갑니다. <br />
      기다리던 통역 기능 스콘챗에서 만나보세요.
    </p>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';

import AnimationAi from '@/components/animations/AnimationAi.vue';
const { t } = useI18n();
</script>

<style scoped lang="scss">
.container-banner {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 25rem;
  background: var(--surface-default);
  padding: 0.75rem 1rem;
  margin-top: 1rem;
  border-radius: 8px;

  z-index: 0;

  &::before {
    content: '';
    position: absolute;
    inset: 0;
    padding: 2px;
    border-radius: inherit;
    background: var(--border-hintbox);
    opacity: 0.8;
    mask:
      linear-gradient(#fff 0 0) content-box,
      linear-gradient(#fff 0 0);
    -webkit-mask-composite: destination-out;
    mask-composite: exclude;
    z-index: -1;
  }
}
</style>
